import React, { useState, useEffect } from 'react';
import { a2aDeveloperService } from '../../a2a/services/a2aDeveloperService.js';
import './AppAnalyticsModule.css';

const AppAnalyticsModule = ({ currentUser, onBack, onTabChange }) => {
  const [analytics, setAnalytics] = useState(null);
  const [selectedApp, setSelectedApp] = useState(null);
  const [apps, setApps] = useState([]);
  const [dateRange, setDateRange] = useState({ 
    start: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    end: new Date().toISOString().split('T')[0]
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Mock apps list - in real implementation, fetch from service
    setApps([
      { id: 'app_1', name: 'My App 1', status: 'published' },
      { id: 'app_2', name: 'My App 2', status: 'published' },
      { id: 'app_3', name: 'My App 3', status: 'draft' }
    ]);
  }, []);

  useEffect(() => {
    if (selectedApp) {
      fetchAppAnalytics();
    }
  }, [selectedApp, dateRange]);

  const fetchAppAnalytics = async () => {
    if (!selectedApp) return;

    setLoading(true);
    try {
      const result = await a2aDeveloperService.getAppAnalytics({
        developer_id: currentUser?.developer_id || currentUser?.id,
        app_id: selectedApp.id,
        start_date: dateRange.start,
        end_date: dateRange.end,
        tenant_id: currentUser?.tenant_id || 'tn_01'
      });
      
      if (result.success) {
        setAnalytics(result.data);
      }
    } catch (error) {
      console.error('Error fetching analytics:', error);
    } finally {
      setLoading(false);
    }
  };

  const MetricCard = ({ title, value }) => {
    return (
      <div className="metric-card">
        <h4>{title}</h4>
        <div className="metric-value">{value || '0'}</div>
      </div>
    );
  };

  return (
    <div className="app-analytics-module">
      <div className="module-header">
        <button onClick={onBack} className="back-btn">← 返回</button>
        <h2>應用分析</h2>
      </div>
      
      <div className="analytics-controls">
        <div className="app-selector">
          <label>選擇應用:</label>
          <select 
            value={selectedApp?.id || ''} 
            onChange={(e) => {
              const app = apps.find(a => a.id === e.target.value);
              setSelectedApp(app || null);
              setAnalytics(null);
            }}
          >
            <option value="">選擇應用</option>
            {apps.map(app => (
              <option key={app.id} value={app.id}>
                {app.name} ({app.status === 'published' ? '已發布' : '草稿'})
              </option>
            ))}
          </select>
        </div>

        {selectedApp && (
          <div className="date-range-selector">
            <label>開始日期:</label>
            <input
              type="date"
              value={dateRange.start}
              onChange={(e) => setDateRange({ ...dateRange, start: e.target.value })}
            />
            <label>結束日期:</label>
            <input
              type="date"
              value={dateRange.end}
              onChange={(e) => setDateRange({ ...dateRange, end: e.target.value })}
            />
          </div>
        )}
      </div>
      
      {loading && (
        <div className="loading">載入分析數據中...</div>
      )}

      {selectedApp && analytics && !loading && (
        <div className="analytics-dashboard">
          <div className="metrics-grid">
            <MetricCard 
              title="總安裝數" 
              value={analytics.total_installations?.toLocaleString()} 
            />
            <MetricCard 
              title="活躍用戶" 
              value={analytics.active_users?.toLocaleString()} 
            />
            <MetricCard 
              title="API 調用" 
              value={analytics.api_calls?.toLocaleString()} 
            />
            <MetricCard 
              title="收入" 
              value={`$${analytics.revenue?.toLocaleString() || '0'}`} 
            />
          </div>
          
          <div className="charts-section">
            <div className="chart-placeholder">
              <h3>安裝趨勢</h3>
              <p>圖表組件待實現</p>
              {analytics.installation_trend && (
                <div className="chart-data">
                  {analytics.installation_trend.map((item, idx) => (
                    <div key={idx} className="chart-item">
                      <span>{item.date}:</span>
                      <span>{item.count}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="chart-placeholder">
              <h3>使用情況</h3>
              <p>圖表組件待實現</p>
              {analytics.usage_data && (
                <div className="chart-data">
                  {analytics.usage_data.slice(0, 5).map((item, idx) => (
                    <div key={idx} className="chart-item">
                      <span>{item.date}:</span>
                      <span>{item.calls} 次調用</span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="chart-placeholder">
              <h3>收入趨勢</h3>
              <p>圖表組件待實現</p>
              {analytics.revenue_data && (
                <div className="chart-data">
                  {analytics.revenue_data.map((item, idx) => (
                    <div key={idx} className="chart-item">
                      <span>{item.date}:</span>
                      <span>${item.amount}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {!selectedApp && (
        <div className="empty-state">
          <p>請選擇一個應用來查看分析數據</p>
        </div>
      )}
    </div>
  );
};

export default AppAnalyticsModule;

